import React, { useContext, useState } from "react";
import {
  Chip,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PageDomain from "../../../../domain";
import { UserListAdvertisementContext } from "../../../../../../../../context/follow-up-widgets";
import { isEmpty } from "lodash";
import "../../style.css";

const PaymentHistoryTable = ({ data, title }) => {
  return (
    <Grid item container direction="column">
      <Typography className="payment-history-table-title">{title}</Typography>
      <TableContainer style={{ marginTop: 16 }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Date and Time</TableCell>
              <TableCell align="center">Amount</TableCell>
              <TableCell align="right">Payment Method</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isEmpty(data) ? (
              <TableRow>
                <TableCell align="center" colSpan={4}>
                  <Typography variant="caption">
                    No Records Available
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row.name}>
                  <TableCell>{PageDomain.formatDateAndTime(row.createdAt)}</TableCell>
                  <TableCell
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      columnGap: 8,
                    }}
                  >
                    {`${row.currency ?? ""} ${row.amount ?? ""}`}
                    {row?.isRecurring && (
                      <Chip size="small" label="Subscription" />
                    )}
                  </TableCell>
                  <TableCell align="right">{row.type ?? ""}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

const PaymentHistoryTabView = () => {
  const { advertisement } = useContext(UserListAdvertisementContext);

  const [tableData, setTableData] = useState({});
  const [isFetchingData, setIsFetchingData] = useState(false);

  const packagesPayments = tableData?.postPayments ?? [];
  const boostAdPayments = tableData?.featuredPaymentHistory ?? [];

  React.useEffect(() => {
    PageDomain.getUserPaymentHistory({
      postId: advertisement.post?.id,
      setTableData,
      setIsFetchingData,
    });
  }, [advertisement]);

  return (
    <Grid
      item
      container
      direction="column"
      className="payment-history-tab-content tab-content"
    >
      {isFetchingData ? (
        <CircularProgress size={15} />
      ) : (
        <Grid
          container
          direction="column"
          className="payment-history-table-view"
        >
          <PaymentHistoryTable
            data={packagesPayments}
            title="Post Payment History"
          />
          <PaymentHistoryTable
            data={boostAdPayments}
            title="Boost Ad Payment History"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default PaymentHistoryTabView;
